<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex flex-col gap-6 bg-gray-50 p-6">
    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Ustawienia koszyka</h5>

      <div class="mt-6 grid gap-x-6">
        <app-form-control label="Usuwaj koszyk po złożeniu zamówienia">
          <p-toggle-switch [formControl]="form.controls.deleteCartAfterCheckout" />
        </app-form-control>
      </div>
    </section>

    <div class="mt-auto flex justify-end">
      <p-button
        appPrimengButton
        label="Zapisz"
        severity="primary"
        type="submit" />
    </div>
  </div>
</form>
